const Layout = ""
const matchRoute = [
  {
    path: "/masterData",
    component: Layout,
    redirect: "/masterData/userCenter",
    name: "MasterData",
    meta: {
      title: "主数据中心",
      icon: "nav_masterdata"
    },
    children: [
      {
        path: "organizational",
        name: "Organizational",
        component: () => "@/views/MasterData/organizational/index",
        meta: {
          title: "组织管理",
          icon: "icon-zuzhiguanli1",
          affix: false
        }
      },
      {
        path: "staff",
        name: "Staff",
        component: () => "@/views/MasterData/staff/index",
        meta: {
          title: "员工管理",
          icon: "icon-yuangongguanli",
          affix: false
        }
      },
      {
        path: "brand",
        name: "Brand",
        component: () => "@/views/MasterData/brand/index",
        meta: {
          title: "品牌管理",
          icon: "icon-pinpaiguanli",
          affix: false
        }
      },
      {
        path: "business",
        name: "Business",
        component: () => "@/views/MasterData/businessType/index",
        meta: {
          title: "业态管理",
          icon: "icon-pinpaiguanli",
          affix: false
        }
      },
      {
        path: "irrigation",
        name: "Irrigation",
        component: () => "@/views/MasterData/irrigation/index",
        meta: {
          title: "渠道管理",
          icon: "icon-qudaoguanli",
          affix: false
        }
      },
      {
        path: "shop",
        name: "Shop",
        component: () => "@/views/MasterData/shop/index",
        meta: {
          title: "店铺管理",
          icon: "icon-dianpuguanli",
          affix: false
        }
      },

      {
        path: "wechat",
        name: "Wechat",
        component: () => "@/views/MasterData/wechat/index",
        meta: {
          title: "微信管理",
          icon: "icon-weixinguanli",
          affix: false
        }
      },
      {
        path: "mobileManagement",
        name: "MobileManagement",
        component: () => "@/views/MasterData/mobileManagement/index",
        meta: {
          title: "手机号管理",
          icon: "icon-weixinguanli",
          affix: false
        }
      },
      {
        path: "corporation",
        name: "Corporation",
        component: () => "@/views/MasterData/corporation/index",
        meta: {
          title: "公司管理",
          icon: "icon-gongsiguanli",
          affix: false
        }
      },
      {
        path: "user",
        name: "User",
        component: () => "@/views/MasterData/user/index",
        meta: {
          title: "用户管理",
          affix: false
        }
      },
      {
        path: "supplier",
        name: "Supplier",
        component: () => "@/views/MasterData/supplier/index",
        meta: {
          title: "供应商管理",
          affix: false
        }
      },
      {
        path: "customer",
        name: "Customer",
        component: () => "@/views/MasterData/customer/index",
        meta: {
          title: "客户与微信绑定管理",
          icon: "icon-kehuyuweiyingxiaobangding",
          affix: false
        }
      },
      {
        path: "fieldDefinition",
        name: "FieldDefinition",
        component: () => "@/views/MasterData/fieldDefinition/index",
        meta: {
          title: "字段定义",
          icon: "icon-yuangongguanli",
          affix: false
        }
      },
      {
        path: "area",
        name: "Area",
        component: () => "@/views/MasterData/area/index",
        meta: {
          title: "地区管理",
          icon: "icon-yuangongguanli",
          affix: false
        }
      },
      {
        path: "logCenter",
        name: "LogCenter",
        component: () => "@/views/MasterData/logCenter/index",
        meta: {
          title: "日志中心",
          affix: false
        }
      },
      {
        path: "noticeSettings",
        name: "NoticeSettings",
        component: () => "@/views/MasterData/noticeSettings/index",
        meta: {
          title: "通知设置",
          affix: false
        }
      },
      {
        path: "exportImport",
        name: "ExportImport",
        component: () => "@/views/MasterData/importExport/index",
        meta: {
          title: "导入导出管理",
          affix: false
        }
      },
      {
        path: "storeLiveManagement",
        name: "StoreLiveManagement",
        component: () => "@/views/MasterData/storeLiveManagement/index",
        meta: {
          title: "店铺直播管理",
          affix: false
        }
      }
    ]
  },
  {
    path: "/count",
    component: Layout,
    redirect: "/count/market/roi",
    name: "SystemCount",
    meta: {
      title: "数据中心",
      icon: "icon-shujuzhongxin"
    },
    children: [
      {
        path: "market",
        name: "MarketRouter",
        redirect: "/count/market/roi",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "微营销报表",
          affix: false,
          icon: "icon-weiyingxiaobaobiao"
        },
        children: [
          {
            path: "roi",
            name: "Roi",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销ROI数据",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "roiReport",
            name: "RoiReport",
            component: () => "@/views/SystemUserData/data-statistics/data-roi-report/index",
            meta: {
              title: "微营销ROI报表",
              affix: false,
              parent: "MarketRouter"
            }
          },

          {
            path: "statisticsReport",
            name: "StatisticsReport",
            component: () => "@/views/SystemUserData/data-statistics/statistics-report/index",
            meta: {
              title: "微营销统计报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "liveSaleReport",
            name: "LiveSaleReport",
            component: () => "@/views/SystemUserData/data-statistics/live-sale-report/index",
            meta: {
              title: "直播销售报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "newSaleReport",
            name: "NewSaleReport",
            component: () => "@/views/SystemUserData/data-statistics/new-sale-report/index",
            meta: {
              title: "新销售销售报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "marketTableIndex",
            name: "MarketTableIndex",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "会员分层模型报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "marketTableDetail",
            name: "MarketTableDetail",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "会员分层模型报表详情",
              affix: false,
              parent: "MarketRouter"
            },
            hidden: true
          },
          {
            path: "marketTableMember",
            name: "marketTableMember",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "会员信息",
              affix: false,
              parent: "MarketRouter"
            },
            hidden: true
          },
          {
            path: "roiNew",
            name: "RoiNew",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销ROI数据",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "deal",
            name: "Deal",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "30天成交报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "operateTable",
            name: "OperateTable",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销运营报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "twoTypeTable",
            name: "TwoTypeTable",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "二类电商运营报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "dropPickTable",
            name: "DropPickTable",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "上门取件报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "productSalesRatioReport",
            name: "ProductSalesRatioReport",
            component: () => "@/views/SystemUserData/operation-table/productSalesRatioReport/index",
            meta: {
              title: "商品产销比报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "inventoryTurnoverReport",
            name: "InventoryTurnoverReport",
            component: () => "@/views/SystemUserData/operation-table/inventoryTurnoverReport/index",
            meta: {
              title: "库存周转报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "stockReport",
            name: "StockReport",
            component: () => "@/views/SystemUserData/operation-table/stockReport/index",
            meta: {
              title: "库存报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "universalProductReport",
            name: "UniversalProductReport",
            component: () => "@/views/SystemUserData/operation-table/stockReport/index",
            meta: {
              title: "商品报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "salesVolume",
            name: "SalesVolume",
            component: () => "@/views/SystemUserData/operation-table/salesVolume/index",
            meta: {
              title: "销售量报表",
              affix: false,
              parent: "MarketRouter"
            }
          },
          {
            path: "goodsSaleReport",
            name: "GoodsSaleReport",
            component: () => "@/views/SystemUserData/data-statistics/goods-sale-report/index",
            meta: {
              title: "商品销售报表",
              affix: false,
              parent: "MarketRouter"
            }
          }
        ]
      },
      {
        path: "promotionTable",
        name: "PromotionRouter",
        redirect: "/count/promotionTable/tencentReport",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "推广报表",
          affix: false,
          icon: "icon-tuiguanbaobiao"
        },
        children: [
          {
            path: "tencentReport",
            name: "TencentReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "腾讯广告报表",
              affix: false,
              parent: "PromotionRouter"
            }
          },
          {
            path: "toutiaoReport",
            name: "ToutiaoReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "头条广告报表",
              affix: false,
              parent: "PromotionRouter"
            }
          },
          {
            path: "totalReport",
            name: "TotalReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "广告汇总报表",
              affix: false,
              parent: "PromotionRouter"
            }
          },
          {
            path: "advRecords",
            name: "AdvRecords",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "广告回传报表",
              affix: false,
              parent: "PromotionRouter"
            }
          },
          {
            path: "recovery",
            name: "RecoveryReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "回本报表",
              affix: false,
              parent: "PromotionRouter"
            }
          }
        ]
      },
      {
        path: "filling",
        name: "FillingRouter",
        redirect: "/count/filling/marketImport",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "数据填报",
          affix: false,
          icon: "icon-shujuxiangguanli"
        },
        children: [
          {
            path: "coreGroupImport",
            name: "CoreGroupImport",
            component: () => "@/views/SystemUserData/data-statistics/coreGroupImport/index",
            meta: {
              title: "集团核心指标",
              affix: false,
              parent: "FillingRouter"
            }
          },
          {
            path: "marketImport",
            name: "MarketImport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "营销单元目标填报",
              affix: false,
              parent: "FillingRouter"
            }
          },
          {
            path: "coreImport",
            name: "CoreImport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "核心指标目标填报",
              affix: false,
              parent: "FillingRouter"
            }
          },
          {
            path: "operateManage",
            name: "OperateManage",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销活动配置",
              affix: false,
              parent: "FillingRouter"
            }
          },
          {
            hidden: true,
            path: "operateManageConfig/create",
            name: "OperateManageConfig",
            props: true,
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销活动配置-新增",
              hidden: true
            }
          },
          {
            hidden: true,
            path: "operateManageConfig/copy",
            name: "OperateManageConfigCopy",
            props: true,
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销活动配置-复制",
              hidden: true
            }
          },
          {
            hidden: true,
            path: "operateManageConfig/:operateType/:id?",
            name: "OperateManageConfig",
            props: true,
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销活动配置-编辑",
              hidden: true
            }
          },
          {
            hidden: true,
            path: "operateManageDetails/details",
            name: "OperateManageDetails",
            props: true,
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "微营销活动配置-详情",
              hidden: true
            }
          },
          {
            path: "timeoutManage",
            name: "TimeoutManage",
            component: () => "@/views/SystemUserData/operation-table/timeoutMange/index",
            meta: {
              title: "超时规则配置",
              affix: false,
              parent: "FillingRouter"
            }
          }
        ]
      },
      {
        path: "dataStatis",
        name: "DataStatis",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "数据统计",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "customerStatis",
            name: "CustomerStatis",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "客户统计",
              icon: "icon-shujutongji",
              affix: false
            }
          },
          {
            hidden: true,
            path: "messageStatis",
            name: "MessageStatis",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "消息统计",
              icon: "icon-yuangongguanli",
              affix: false
            }
          }
        ]
      },
      {
        path: "customer",
        name: "Customer",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "客户与微信绑定管理",
          icon: "icon-kehuyuweiyingxiaobangding",
          affix: false
        }
      },
      {
        path: "promotion",
        name: "Promotion",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "推广统计表",
          icon: "icon-tuiguantongji",
          affix: false
        }
      },
      {
        path: "drivePage",
        name: "DrivePage",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "驾驶舱",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "drivePageV2",
        name: "DrivePageV2",
        component: () => "@/views/SystemUserData/data-statistics/drivePage/indexV2",
        meta: {
          title: "数据罗盘",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "fullScreen",
        name: "FullScreen",
        component: () => "@/views/SystemUserData/data-statistics/fullscreen/index",
        meta: {
          title: "销售大屏",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "dailyReport",
        name: "DailyReport",
        component: () => "@/views/SystemUserData/data-statistics/daily-report/index",
        meta: {
          title: "集团日报",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "marketPage",
        name: "MarketPage",
        component: () => "@/views/SystemUserData/data-statistics/marketPage/index",
        meta: {
          title: "数据看板",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "fansMarketPage",
        name: "FansMarketPage",
        component: () => "@/views/SystemUserData/data-statistics/fansMarketPage/index",
        meta: {
          title: "新粉数据看板",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "contentReport",
        name: "ContentReportRouter",
        redirect: "/count/contentReport/friendCircleMaterial",
        component: () => "@/views/SystemUserData/data-statistics/contentReport/router",
        meta: {
          title: "内容报表",
          affix: false,
          icon: "icon-dingdanliebiao"
        },
        children: [
          {
            path: "friendCircleMaterial",
            name: "FriendCircleMaterial",
            component: () => "@/views/SystemUserData/data-statistics/contentReport/friendCircleMaterial",
            meta: {
              title: "朋友圈素材报表",
              affix: false,
              parent: "ContentReportRouter"
            }
          }
        ]
      },

      {
        path: "customerServiceReport",
        name: "CustomerServiceReportRouter",
        redirect: "/count/timeoutReport/report",
        component: () => "@/views/SystemUserData/data-statistics/timeout-report/router",
        meta: {
          title: "客服报表",
          affix: false,
          icon: "icon-dingdanliebiao"
        },
        children: [
          {
            path: "timeoutReport",
            name: "TimeoutReport",
            component: () => "@/views/SystemUserData/data-statistics/timeout-report/report",
            meta: {
              title: "超时记录报表",
              affix: false,
              parent: "TimeoutReport"
            }
          }
        ]
      },

      {
        path: "advertReport",
        name: "AdvertReport",
        redirect: "/count/advertReport/records",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "广告报表",
          icon: "nav_IntelligentMarketing",
          affix: false
        },
        children: [
          {
            path: "tencentReport",
            name: "TencentReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "腾讯广告报表",
              affix: false,
              parent: "AdvertReport"
            }
          },
          {
            path: "toutiaoReport",
            name: "ToutiaoReport",
            component: () => "@/views/SystemUserData/data-statistics/router",
            meta: {
              title: "头条广告报表",
              affix: false,
              parent: "AdvertReport"
            }
          }
        ]
      },
      {
        path: "recovery",
        name: "RecoveryReport",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "回本报表",
          icon: "icon-tuiguangxinxi",
          affix: false
        }
      },
      {
        path: "fanruan",
        name: "FanruanIndex",
        component: () => "@/views/SystemUserData/data-statistics/router",
        meta: {
          title: "帆软报表",
          affix: false
        },
        hidden: true
      },
      {
        path: "fanruanAB",
        name: "ABclient",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/ABclient",
        meta: {
          title: "帆软报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "fanruanChannel",
        name: "FanruanChannel",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/fanruanChannel",
        meta: {
          title: "帆软报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "performanceReport",
        name: "PerformanceReport",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/performanceReport",
        meta: {
          title: "一二开业绩报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "repurchaseRate",
        name: "RepurchaseRate",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/repurchaseRate",
        meta: {
          title: "微营销复购率报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "timePromotionExpend",
        name: "TimePromotionExpend",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/timePromotionExpend",
        meta: {
          title: "时点推广消耗",
          affix: false,
          isIframe: true
        },
        hidden: false
      },

      {
        path: "storeLiveReport",
        name: "StoreLiveReport",
        component: () => "@/views/SystemUserData/data-statistics/storeLive-report/index",
        meta: {
          title: "主播排班记录",
          icon: "icon-drive",
          affix: false
        },
        hidden: false
      },
      {
        path: "storeDataInput",
        name: "StoreDataInput",
        component: () => "@/views/SystemUserData/data-statistics/shops-data-input/index",
        meta: {
          title: "唯品会&京东数据录入",
          icon: "icon-drive",
          affix: false
        }
      },

      {
        path: "pushArticlesWithTopData",
        name: "PushArticlesWithTopData",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/pushArticlesWithTopData.vue",
        meta: {
          title: "推文置顶数据",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "pushArticlesWithReadData",
        name: "PushArticlesWithReadData",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/pushArticlesWithReadData.vue",
        meta: {
          title: "推文阅读数据",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "pushArticlesWithAdReport",
        name: "PushArticlesWithAdReport",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/pushArticlesWithAdReport.vue",
        meta: {
          title: "推文广告报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "channelReturnEstimationReport",
        name: "ChannelReturnEstimationReport",
        component: () => "@/views/SystemUserData/data-statistics/fanruan-iframe/pushArticlesWithTopData.vue",
        meta: {
          title: "渠道退货预估报表",
          affix: false,
          isIframe: true
        },
        hidden: false
      },
      {
        path: "interestOperationsReport",
        name: "InterestOperationsReport",
        component: () => "@/views/SystemUserData/data-statistics/contentReport/interestOperationsReport",
        meta: {
          title: "兴趣运营报表",
          affix: false,
          parent: "ContentReportRouter"
        }
      },
      {
        path: "interestOrderInput",
        name: "InterestOrderInput",
        component: () => "@/views/SystemUserData/data-statistics/contentReport/interestOrderInput",
        meta: {
          title: "兴趣订单类型导入",
          affix: false,
          parent: "ContentReportRouter"
        }
      },

      {
        path: "supplier",
        name: "Supplier",
        component: () => "@/views/SystemUserData/supplier/index",
        meta: {
          title: "至上力合",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "standard",
            name: "SupplierStandard",
            component: () => "@/views/SystemUserData/supplier/standard/index",
            meta: {
              title: "服务标准信息",
              icon: "icon-shujutongji",
              affix: false
            }
          },
          {
            hidden: true,
            path: "data",
            name: "SupplierData",
            component: () => "@/views/SystemUserData/supplier/supplierData/index",
            meta: {
              title: "供应商服务数据",
              icon: "icon-yuangongguanli",
              affix: false
            }
          },
          {
            hidden: true,
            path: "bill",
            name: "SupplierBill",
            component: () => "@/views/SystemUserData/supplier/bill/index",
            meta: {
              title: "供应商账单",
              icon: "icon-yuangongguanli",
              affix: false
            }
          },
          {
            hidden: true,
            path: "issue",
            name: "IssueRecords",
            component: () => "@/views/SystemUserData/supplier/issueRecords/index",
            meta: {
              title: "服务问题记录",
              icon: "icon-yuangongguanli"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/advert",
    component: Layout,
    redirect: "/advert/accountManage",
    name: "Advert",
    meta: {
      title: "广告系统",
      icon: "nav_advert"
    },
    children: [
      {
        path: "menuSetting",
        name: "MenuSetting",
        component: () => "@/views/Advert/menuSetting/index",
        meta: {
          title: "自定义菜单",
          icon: "icon-zidingyicaidan",
          affix: false
        }
      },
      {
        path: "source",
        name: "Source",
        component: () => "@/views/Advert/source/index",
        meta: {
          title: "素材管理",
          icon: "icon-sucaiguanli",
          affix: false
        },
        children: []
      },
      {
        path: "editSource",
        name: "EditSource",
        component: () => "@/views/Advert/source/edit/index",
        meta: {
          title: "编辑图文",
          affix: false
        },
        hidden: true
      },
      {
        path: "accountManage",
        name: "AccountManage",
        component: () => "@/views/Advert/accountManage/index",
        meta: {
          title: "公众号管理",
          icon: "icon-gongzhonghaoguanli",
          affix: false
        }
      },
      {
        path: "accountReply",
        name: "AccountReply",
        redirect: "/advert/accountReply/index",
        component: () => "@/views/Advert/accountReply/router",
        meta: {
          title: "二级路由",
          icon: "icon-huifushezhi",
          affix: false
        },
        children: [
          {
            path: "index",
            name: "AccountReplyList",
            component: () => "@/views/Advert/accountReply/index",
            meta: {
              title: "回复设置",
              icon: "icon-huifushezhi",
              affix: false,
              parent: "AccountReply"
            }
          },
          {
            path: "add",
            name: "AccountReplyAdd",
            component: () => "@/views/Advert/accountReply/add",
            meta: {
              title: "添加消息",
              affix: false,
              tagsFrom: "AccountReplyList"
            },
            hidden: true
          },
          {
            path: "edit/:id",
            name: "AccountReplyEdit",
            component: () => "@/views/Advert/accountReply/add",
            meta: {
              title: "编辑消息",
              affix: false,
              tagsFrom: "AccountReplyList"
            },
            hidden: true
          }
        ]
      },
      {
        path: "keyReply",
        name: "KeyReply",
        redirect: "/advert/keyReply/index",
        component: () => "@/views/Advert/keyReply/router",
        meta: {
          title: "二级路由",
          icon: "icon-yuangongguanli",
          affix: false
        },
        children: [
          {
            path: "index",
            name: "KeyReplyList",
            component: () => "@/views/Advert/keyReply/index",
            meta: {
              title: "关键词回复",
              icon: "icon-yuangongguanli",
              affix: false,
              parent: "KeyReply"
            }
          },
          {
            path: "add",
            name: "KeyReplyAdd",
            component: () => "@/views/Advert/keyReply/add",
            meta: {
              title: "添加关键词回复",
              affix: false,
              tagsFrom: "KeyReplyList"
            },
            hidden: true
          },
          {
            path: "edit/:id",
            name: "KeyReplyEdit",
            component: () => "@/views/Advert/keyReply/add",
            meta: {
              title: "编辑关键词回复",
              affix: false,
              tagsFrom: "KeyReplyList"
            },
            hidden: true
          }
        ]
      },
      {
        path: "intelligentGuide",
        name: "IntelligentGuide",
        component: () => "@/views/Advert/intelligentGuide/index",
        meta: {
          title: "智能导流",
          affix: false
        }
      },
      {
        path: "pageTemplate",
        name: "PageTemplate",
        component: () => "@/views/Advert/intelligentGuide/pageTemplate",
        meta: {
          title: "落地页模板",
          affix: false
        }
      },
      {
        path: "miniProgramPage",
        name: "MiniProgramPage",
        component: () => "@/views/Advert/intelligentGuide/miniProgramPage",
        meta: {
          title: "小程序落地页",
          affix: false
        }
      },
      {
        path: "templateEdit",
        name: "TemplateEdit",
        component: () => "@/views/Advert/intelligentGuide/templateEdit",
        meta: {
          title: "模板编辑",
          affix: false,
          parent: "pageTemplate"
        },
        hidden: true
      },
      {
        path: "h5TemplateEdit",
        name: "H5TemplateEdit",
        component: () => "@/views/Advert/intelligentGuide/h5TemplateEdit",
        meta: {
          title: "h5模板编辑",
          affix: false,
          parent: "pageTemplate"
        },
        hidden: true
      },
      {
        path: "intelligentMarketing",
        name: "IntelligentMarketing",
        redirect: "/advert/intelligentMarketing/index",
        component: () => "@/views/Advert/intelligentMarketing/router",
        meta: {
          title: "智能营销",
          icon: "nav_IntelligentMarketing",
          affix: false
        },
        children: [
          {
            path: "index",
            name: "IntelligentMarketingList",
            component: () => "@/views/Advert/intelligentMarketing/index",
            meta: {
              title: "智能接待列表",
              affix: false,
              parent: "IntelligentMarketing"
            }
          },
          {
            path: "add",
            name: "IntelligentMarketingAdd",
            component: () => "@/views/Advert/intelligentMarketing/add",
            meta: {
              title: "新建智能接待",
              affix: false
            },
            hidden: true
          },
          {
            path: ":id",
            name: "IntelligentMarketingEdit",
            component: () => "@/views/Advert/intelligentMarketing/add",
            meta: {
              title: "智能接待编辑",
              affix: false
            },
            hidden: true
          }
        ]
      },
      {
        path: "performanceTest",
        name: "PerformanceTest",
        component: () => "@/views/Advert/performanceTest/index",
        meta: {
          title: "性能单",
          affix: false
        }
      },
      {
        path: "verifyData",
        name: "VerifyData",
        component: () => "@/views/Advert/verifyData/index",
        meta: {
          title: "核对单",
          affix: false
        }
      },
      {
        path: "advRecords",
        name: "AdvRecords",
        component: () => "@/views/Advert/advRecords/index",
        meta: {
          title: "广告回传报表",
          affix: false
        }
      },
      {
        path: "advOperateSetting",
        name: "advOperateSetting",
        component: () => "@/views/Advert/advOperateSetting/index",
        meta: {
          title: "广告系统设置",
          affix: false
        }
      },
      {
        path: "manageAccount",
        name: "manageAccount",
        redirect: "/advert/manageAccount/main",
        component: () => "@/views/Advert/manageAccount/router",
        meta: {
          title: "账号管理",
          icon: "nav_IntelligentMarketing",
          affix: false
        },
        children: [
          {
            path: "main",
            name: "ManageAccountMain",
            component: () => "@/views/Advert/manageAccount/main",
            meta: {
              title: "主账号管理",
              affix: false,
              parent: "manageAccount"
            }
          },
          {
            path: "child",
            name: "manageAccountChild",
            component: () => "@/views/Advert/manageAccount/child",
            meta: {
              title: "子账号管理",
              affix: false,
              parent: "manageAccount"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/cdp",
    component: Layout,
    redirect: "relationTable",
    name: "Cdp",
    meta: {
      title: "Cdp",
      icon: "icon-menuCdp"
    },
    children: [
      {
        path: "relationTable",
        name: "RelationTable",
        component: () => "@/views/Cdp/RelationTable/index",
        meta: {
          title: "CDP关系表",
          icon: "icon-kehuyuweiyingxiaobangding",
          affix: false,
          parent: "Cdp"
        }
      },
      {
        path: "assetsEarlyPoint",
        name: "AssetsEarlyWarningPoint",
        component: () => "@/views/Cdp/memberEarlyWarning/point",
        meta: {
          title: "会员资产预警",
          affix: false,
          parent: "Cdp",
          noCache: false
        }
      },
      {
        path: "assetsEarlyExp",
        name: "AssetsEarlyWarningExp",
        component: () => "@/views/Cdp/memberEarlyWarning/exp",
        meta: {
          title: "经验值预警",
          affix: false,
          parent: "Cdp",
          noCache: false
        }
      },
      {
        path: "rightsCenter",
        name: "RightsCenter",
        component: () => "@/views/Cdp/rightsCenter/index",
        meta: {
          title: "权益中心",
          icon: "icon-quanyizhongxin",
          affix: false,
          parent: "Cdp",
          noCache: false
        }
      },
      {
        path: "userCenter/index",
        name: "CdpUserCenterList",
        component: () => "@/views/Cdp/userCenter/index",
        meta: {
          title: "会员中心",
          icon: "icon-huiyuanzhongxin",
          affix: false,
          parent: "Cdp",
          noCache: false
        }
      },
      {
        path: "behaviorCenter/index",
        name: "BehaviorCenter",
        component: () => "@/views/Cdp/behaviorCenter/index",
        meta: {
          title: "行为中心",
          icon: "icon-behavioral-portrait_",
          parent: "Cdp"
        }
      },
      {
        path: "customerOperations",
        name: "CustomerOperations",
        component: () => "@/views/Cdp/index",
        meta: {
          title: "客户运营",
          icon: "icon-kehuyunying"
        },
        children: [
          {
            path: "crowdPack/index",
            name: "CrowdPack",
            component: () => "@/views/Cdp/crowdPack/index",
            meta: {
              title: "人群包",
              parent: "CustomerOperations"
            }
          },
          {
            path: "newMemberPage/index",
            name: "NewMemberPage",
            component: () => "@/views/Cdp/newMemberPage/index",
            meta: {
              title: "会员查询",
              parent: "CustomerOperations"
            }
          },
          {
            path: "crowdPack/add",
            name: "CrowdPackAdd",
            hidden: true,
            component: () => "@/views/Cdp/crowdPack/add",
            meta: {
              title: "人群包-操作",
              parent: "CustomerOperations",
              tagsFrom: "CrowdPack"
            }
          },
          {
            path: "newCrowdPack/index",
            name: "NewCrowdPack",
            component: () => "@/views/Cdp/newCrowdPack/index",
            meta: {
              title: "新人群包",
              parent: "CustomerOperations"
            }
          },

          {
            path: "newCrowdPack/add",
            name: "NewCrowdPackAdd",
            hidden: true,
            component: () => "@/views/Cdp/newCrowdPack/add",
            meta: {
              title: "人群包",
              parent: "CustomerOperations",
              tagsFrom: "CrowdPack"
            }
          },

          {
            path: "rfm/index",
            name: "RFM",
            component: () => "@/views/Cdp/RFM/index",
            meta: {
              title: "RFM标签",
              parent: "CustomerOperations"
            }
          },

          {
            path: "rfm/detail",
            name: "RFMDetail",
            component: () => "@/views/Cdp/RFM/detail",
            meta: {
              title: "RFM详情",
              affix: false,
              parent: "CustomerOperations",
              tagsFrom: "RFM"
            },
            hidden: true
          },

          {
            path: "rfm/add",
            name: "RFMAdd",
            component: () => "@/views/Cdp/RFM/add",
            meta: {
              title: "RFM新增",
              affix: false,
              parent: "CustomerOperations",
              tagsFrom: "RFM"
            },
            hidden: true
          },
          {
            path: "fieldManagement/index",
            name: "fieldManagement",
            component: () => "@/views/Cdp/fieldManagement/index",
            meta: {
              title: "标签规则字段管理",
              parent: "CustomerOperations"
            }
          },
          {
            path: "tagRecords/index",
            name: "TagRecords",
            component: () => "@/views/Cdp/tagRecords/index",
            meta: {
              title: "标签管理",
              parent: "CustomerOperations"
            }
          }
        ]
      },

      {
        path: "userCenter/point",
        name: "UserCenterIntegral",
        component: () => "@/views/Cdp/userCenter/point",
        meta: {
          title: "积分列表",
          affix: false,
          parent: "Cdp",
          tagsFrom: "RightsCenter"
        },
        hidden: true
      },
      {
        path: "userCenter/point",
        name: "UserCenterIntegral2",
        component: () => "@/views/Cdp/userCenter/point",
        meta: {
          title: "积分列表",
          affix: false,
          parent: "Cdp",
          tagsFrom: "CdpUserCenterList"
        },
        hidden: true
      },

      {
        path: "userCenter/memberDetails",
        name: "MemberDetails",
        component: () => "@/views/Cdp/userCenter/memberDetails",
        meta: {
          title: "会员详情",
          affix: false,
          parent: "Cdp",
          tagsFrom: "CdpUserCenterList"
        },
        hidden: true
      },
      {
        path: "userCenter/fansDetails",
        name: "FansDetails",
        component: () => "@/views/Cdp/userCenter/fansDetails",
        meta: {
          title: "粉丝详情",
          affix: false,
          parent: "Cdp",
          tagsFrom: "CdpUserCenterList"
        },
        hidden: true
      },
      {
        path: "userCenter/growth",
        name: "UserCenterExperience",
        component: () => "@/views/Cdp/userCenter/growth",
        meta: {
          title: "经验值列表",
          affix: false,
          parent: "Cdp",
          tagsFrom: "RightsCenter"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/customCenter",
    component: Layout,
    redirect: "workOrder",
    name: "CustomCenter",
    meta: {
      title: "客服中心",
      icon: "icon-kefuzhongxin"
    },
    children: [
      {
        path: "workOrder",
        name: "WorkOrder",
        component: () => "@/views/CustomCenter/workOrder/index",
        meta: {
          title: "工单管理",
          icon: "icon-dingdanliebiao",
          affix: false,
          parent: "customCenter"
        }
      },
      {
        path: "saleAfter",
        name: "SaleAfter",
        component: () => "@/views/CustomCenter/saleAfter/index",
        meta: {
          title: "售后处理",
          icon: "icon-a-ziyuan1",
          affix: false,
          parent: "customCenter"
        }
      },
      {
        path: "customerComplaint",
        name: "CustomerComplaint",
        component: () => "@/views/CustomCenter/customerComplaint/index",
        meta: {
          title: "客诉处理",
          icon: "icon-kesuchuli",
          affix: false,
          parent: "customCenter"
        }
      },
      {
        path: "freightInsurance",
        name: "FreightInsurance",
        meta: {
          title: "运费险",
          parent: "customCenter"
        },
        children: [
          {
            path: "quotaManagement",
            name: "QuotaManagement",
            meta: {
              title: "额度管理",
              parent: "FreightInsurance"
            }
          },
          {
            path: "billManagement",
            name: "BillManagement",
            meta: {
              title: "账单管理",
              parent: "FreightInsurance"
            }
          }
        ]
      },
      // {
      //   path: "ITR",
      //   // component: Layout,
      //   // redirect: "workOrder",
      //   name: "ITR",
      //   meta: {
      //     title: "ITR"
      //     // icon: "icon-kefuzhongxin"
      //   },
      //   children: [
      {
        path: "ITRList",
        name: "ITRList",
        component: () => "@/views/ITR/ITRList/itrList.vue",
        meta: {
          title: "工单处理",
          icon: "icon-kesuchuli",
          affix: false,
          parent: "ITR"
        }
      },
      {
        path: "itrDetail",
        name: "itrDetail",
        component: () => "@/views/ITR/ITRList/itrDetail.vue",
        meta: { title: "工单详情", icon: "icon-xitongguanli", tagsFrom: "ITRList" },
        hidden: true
      },
      {
        path: "itrDetailHandle",
        name: "itrDetailHandle",
        component: () => "@/views/ITR/ITRList/itrDetailHandle.vue",
        meta: { title: "工单处理详情", icon: "icon-xitongguanli", tagsFrom: "ITRList" },
        hidden: true
      },
      {
        path: "ITRStandardList",
        name: "ITRStandardList",
        component: () => "@/views/ITR/ITRStandard/ITRStandardList.vue",
        meta: {
          title: "工单处理标准",
          icon: "icon-kesuchuli",
          affix: false,
          parent: "ITR"
        }
      },
      {
        path: "roleMatrix",
        name: "roleMatrix",
        component: () => "@/views/ITR/RoleMatrix/RoleMatrix.vue",
        meta: {
          title: "角色矩阵",
          icon: "icon-kesuchuli",
          affix: false,
          parent: "ITR"
        }
      },
      {
        path: "BaseSettingList",
        name: "BaseSettingList",
        component: () => "@/views/ITR/BaseSetting/BaseSettingList.vue",
        meta: {
          title: "基础信息设置",
          icon: "icon-kesuchuli",
          affix: false,
          parent: "ITR"
        }
      }
      //   ]
      // }
    ]
  },
  {
    path: "/logistics",
    component: Layout,
    redirect: "LogisticsSearch",
    name: "Logistics",
    meta: {
      title: "物流中心",
      icon: "icon-wuliuzhongxin"
    },
    children: [
      {
        path: "search",
        name: "LogisticsSearch",
        component: () => "@/views/Logistics/search/index",
        meta: {
          title: "物流查询",
          icon: "icon-wuliuchaxun",
          affix: false,
          parent: "Logistics"
        }
      }
    ]
  },
  {
    path: "/product",
    component: Layout,
    name: "ProductCenter",
    meta: {
      title: "商品中心",
      icon: "icon-shangpinzhongxin"
    },
    children: [
      {
        path: "list",
        name: "ProductList",
        component: () => "@/views/Product/list/index",
        meta: {
          title: "商品列表",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "ProductCenter"
        }
      },
      {
        path: "tagList",
        name: "TagList",
        component: () => "@/views/Product/tag/tagList",
        meta: {
          title: "商品标签",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "ProductCenter"
        }
      },
      {
        hidden: true,
        path: "detail",
        name: "ProductDetail",
        props: true,
        component: () => "@/views/Product/list/detail",
        meta: {
          title: "商品详情",
          hidden: true,
          tagsFrom: "ProductList"
        }
      },
      {
        path: "compose",
        name: "ProductCompose",
        component: () => "@/views/Product/compose/index",
        meta: {
          title: "组合列表",
          icon: "icon-zuheliebiao",
          affix: false,
          parent: "ProductCenter"
        }
      },
      {
        hidden: true,
        path: "composeDetail/:id",
        name: "ProductComposeDetail",
        props: true,
        component: () => "@/views/Product/compose/detail",
        meta: {
          title: "组合详情",
          hidden: true,
          tagsFrom: "ProductCompose"
        }
      },
      {
        path: "categoryManageIndex",
        name: "CategoryManageIndex",
        component: () => "@/views/Product/categoryManage/index",
        meta: {
          title: "类目管理",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "ProductCenter"
        }
      }
    ]
  },
  {
    path: "/orderCenter",
    component: Layout,
    redirect: "/orderCenter/masterOrderList",
    name: "orderCenter",
    meta: { title: "订单中心", icon: "icon-dingdanzhongxin" },
    children: [
      {
        path: "masterOrderList",
        name: "MasterOrderList",
        component: () => "@/views/OrderCenter/order-list",
        meta: { title: "订单列表", icon: "icon-dingdanliebiao" }
      },
      {
        path: "masterOrderDetail",
        name: "MasterOrderDetail",
        component: () => "@/views/OrderCenter/order-list/detail",
        meta: { title: "订单详情", icon: "icon-xitongguanli", tagsFrom: "MasterOrderList" },
        hidden: true
      }
    ]
  },
  {
    path: "/authorityCenter",
    component: Layout,
    redirect: "/authorityCenter/sysManger",
    name: "authorityCenter",
    meta: { title: "权限中心", icon: "icon-quanxianzhongxin" },
    children: [
      {
        path: "sysManger",
        name: "SysManger",
        component: () => "@/views/AuthorityCenter/sysManger",
        meta: { title: "系统管理" }
      },
      {
        path: "roleManger",
        name: "RoleMangerNew",
        component: () => "@/views/AuthorityCenter/roleManger/index-new",
        meta: { title: "角色管理" }
      },
      {
        path: "roleMangerOld",
        name: "RoleManger",
        component: () => "@/views/AuthorityCenter/roleManger/index",
        meta: { title: "角色管理-老" }
      },
      {
        path: "datasRoleManger",
        name: "DatasRoleMangerNew",
        component: () => "@/views/AuthorityCenter/datasRoleManger/index-new",
        meta: { title: "数据角色管理" }
      },
      {
        path: "datasRoleMangerOld",
        name: "DatasRoleManger",
        component: () => "@/views/AuthorityCenter/datasRoleManger/index",
        meta: { title: "数据角色管理-老" }
      },
      {
        path: "authManger",
        name: "AuthManger",
        component: () => "@/views/AuthorityCenter/authManger",
        meta: { title: "权限管理" }
      }
    ]
  },
  {
    path: "/userData",
    component: Layout,
    redirect: "/userData/wxChat",
    name: "SystemUserData",
    meta: {
      title: "WCT",
      icon: "nav_customer_data_platform"
    },
    children: [
      {
        path: "marketPage",
        name: "MarketPage",
        component: () => "@/views/SystemUserData/data-statistics/marketPage",
        meta: {
          title: "微营销工作台",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "wxChat",
        name: "WxChat",
        component: () => "@/views/SystemUserData/wx-chat",
        meta: {
          title: "微营销会话",
          icon: "nav_wechat"
        }
      },
      {
        path: "wxManagement",
        name: "WxManagement",
        component: () => "@/views/SystemUserData/wx-management",
        meta: {
          title: "微信号管理",
          icon: "nav_wechat_magage"
        }
      },

      {
        path: "groupManagement",
        name: "GroupManagement",
        component: () => "@/views/SystemUserData/group-management",
        meta: {
          title: "社群运营",
          icon: "icon-shequnyunying"
        }
      },
      {
        hidden: true,
        path: "groupManagementConfig/:operateType/:id?",
        name: "GroupManagementConfig",
        props: true,
        component: () => "@/views/SystemUserData/group-management/group-config",
        meta: {
          title: "批量拉群",
          hidden: true,
          tagsFrom: "GroupManagement"
        }
      },

      {
        hidden: true,
        path: "groupManagementConfigDetail/:id",
        name: "GroupManagementConfigDetail",
        component: () => "@/views/SystemUserData/group-management/group-config-detail",
        props: true,
        meta: {
          title: "拉群详情",
          hidden: true,
          tagsFrom: "GroupManagement"
        }
      },

      {
        path: "groupMsg",
        name: "GroupMsg",
        component: () => "@/views/SystemUserData/group-msg",
        meta: {
          title: "消息群发",
          icon: "nav_wechat_magage"
        }
      },
      {
        hidden: true,
        path: "msgConfig/:operateType/:id?",
        name: "MsgConfig",
        props: true,
        component: () => "@/views/SystemUserData/group-msg/msg-config",
        meta: {
          title: "群发消息",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },
      {
        hidden: true,
        path: "msgConfigDetail/:id",
        name: "MsgConfigDetail",
        component: () => "@/views/SystemUserData/group-msg/msg-config-detail",
        props: true,
        meta: {
          title: "群发消息详情",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },

      {
        path: "historyMsg",
        name: "HistoryMsg",
        component: () => "@/views/SystemUserData/history-msg/index",
        meta: {
          title: "历史消息",
          icon: "nav_wechat_history"
        }
      },
      {
        hidden: true,
        path: "resetPsw",
        name: "resetPsw",
        component: () => "@/views/SystemUserData/reset-psw/index",
        meta: {
          title: "修改密码",
          icon: "example"
        }
      },
      {
        path: "userCenter",
        name: "UserCenter",
        component: () => "@/views/SystemUserData/user-center/index",
        meta: {
          title: "会员中心",
          icon: "nav_wechat_member_center"
        },
        children: [
          {
            path: "list",
            name: "UserCenterList",
            component: () => "@/views/SystemUserData/user-center/list/index",
            meta: {
              title: "会员中心",
              icon: "nav_wechat_member_center",
              parent: "UserCenter"
            }
          },
          {
            hidden: true, // (默认 false)
            path: "list/:id",
            name: "userCenterDetail",
            component: () => "@/views/SystemUserData/user-center/detail/index",
            meta: {
              title: "会员中心详情",
              icon: "nav_wechat_member_center",
              hidden: true
            }
          }
        ]
      },
      {
        path: "exportMembers",
        name: "exportMembers",
        component: () => "@/views/SystemUserData/export-members/index",
        meta: {
          title: "会员导出",
          icon: "icon-huiyuandaochu",
          affix: false
        }
      },
      {
        path: "dataStatis",
        name: "DataStatis",
        component: () => "@/views/SystemUserData/data-statistics/index",
        meta: {
          title: "数据统计",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "customerStatis",
            name: "CustomerStatis",
            component: () => "@/views/SystemUserData/data-statistics/customer/index",
            meta: {
              title: "客户统计",
              icon: "icon-shujutongji",
              affix: false,
              parent: "DataStatis"
            }
          },
          {
            path: "messageStatis",
            name: "MessageStatis",
            component: () => "@/views/SystemUserData/data-statistics/message/index",
            meta: {
              title: "消息统计",
              icon: "icon-yuangongguanli",
              affix: false,
              parent: "DataStatis"
            }
          }
        ]
      },
      {
        path: "wechatMoments",
        name: "WechatMoments",
        component: () => "@/views/SystemUserData/wx-moments",
        meta: {
          title: "朋友圈",
          icon: "nav_moments"
        },
        children: [
          {
            path: "engineMoments",
            name: "EngineMoments",
            component: () => "@/views/SystemUserData/wx-moments/engine/index",
            meta: {
              title: "批量发圈",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            path: "editMoments",
            name: "EditMoments",
            hidden: true,
            component: () => "@/views/SystemUserData/wx-moments/engine/edit/index",
            meta: {
              title: "发表朋友圈",
              tagsFrom: "EngineMoments"
            }
          },
          {
            path: "commentMoments",
            name: "CommentMoments",
            component: () => "@/views/SystemUserData/wx-moments/comment/index",
            meta: {
              title: "朋友圈评论",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            hidden: false,
            path: "viewMoments",
            name: "ViewMoments",
            component: () => "@/views/SystemUserData/wx-moments/view/index",
            meta: {
              title: "查看朋友圈",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            path: "sourceMoments",
            name: "SourceMoments",
            component: () => "@/views/SystemUserData/wx-moments/source/index",
            meta: {
              title: "朋友圈素材",
              affix: false
            }
          },
          {
            path: "SourceMomentsEdit/:id",
            name: "SourceMomentsEdit",
            component: () => "@/views/SystemUserData/wx-moments/source/edit",
            meta: {
              title: "朋友圈素材-编辑",
              affix: false,
              parent: "WechatMoments",
              tagsFrom: "SourceMoments"
            },
            hidden: true
          },
          {
            path: "sourceMomentsAdd",
            name: "SourceMomentsAdd",
            component: () => "@/views/SystemUserData/wx-moments/source/add",
            meta: {
              title: "朋友圈素材-新增",
              affix: false,
              parent: "WechatMoments",
              tagsFrom: "SourceMoments"
            },
            hidden: true
          },
          {
            path: "autoSendMoment",
            name: "AutoSendMoment",
            component: () => "@/views/SystemUserData/wx-moments/autoSendMoment",
            meta: {
              title: "自动发圈设置",
              affix: false
            }
          }
        ]
      },
      {
        path: "automaticOperation",
        name: "AutomaticOperation",
        component: () => "@/views/SystemUserData/automatic-operation/index",
        meta: {
          title: "自动化运营",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "greeting",
            name: "Greeting",
            component: () => "@/views/SystemUserData/automatic-operation/greeting/index",
            meta: {
              title: "客户欢迎语",
              affix: false,
              parent: "AutomaticOperation"
            }
          },
          {
            hidden: true,
            path: "greetingConfig/:operateType/:id?",
            name: "GreetingConfig",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/greeting/greeting-config",
            meta: {
              title: "客户欢迎语设置",
              tagsFrom: "Greeting",
              hidden: true
            }
          },
          {
            hidden: true,
            path: "greetingDetail/:id",
            name: "GreetingDetail",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/greeting/greeting-detail",
            meta: {
              title: "客户欢迎语详情",
              tagsFrom: "Greeting",
              hidden: true
            }
          },
          {
            path: "automaticFans",
            name: "AutomaticFans",
            component: () => "@/views/SystemUserData/automatic-operation/automatic-fans",
            meta: {
              title: "自动加粉",
              affix: false
            }
          },
          {
            hidden: true,
            path: "automaticRecord/:id",
            name: "AutomaticRecord",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/automatic-record",
            meta: {
              title: "自动加粉详情",
              icon: "icon-shujutongji",
              tagsFrom: "AutomaticFans",
              affix: false
            }
          }
        ]
      },
      {
        path: "riskControl",
        name: "RiskControl",
        component: () => "@/views/SystemUserData/risk-control",
        meta: {
          title: "风控设置",
          icon: "nav_risk"
        }
      },
      {
        path: "sensitiveWords",
        name: "SensitiveWords",
        component: () => "@/views/SystemUserData/sensitive-words",
        meta: {
          title: "敏感词设置",
          icon: "icon-huiyuandaochu"
        }
      },
      {
        path: "sensitiveWordsConfig/:operate/:id?",
        name: "SensitiveWordsConfig",
        component: () => "@/views/SystemUserData/sensitive-words/config",
        meta: {
          title: "敏感词设置",
          icon: "icon-huiyuandaochu",
          tagsFrom: "SensitiveWords"
        },
        hidden: true,
        props: true
      },
      {
        path: "warnTable",
        name: "WarnTable",
        component: () => "@/views/SystemUserData/warn-table/index",
        meta: {
          title: "告警表",
          icon: "menu_warn"
        }
      }
    ]
  },
  {
    path: "/voyager",
    component: Layout,
    redirect: "/voyager/wxChat",
    name: "SystemUserData",
    meta: {
      title: "WCT",
      icon: "nav_customer_data_platform"
    },
    children: [
      {
        path: "marketPage",
        name: "MarketPage",
        component: () => "@/views/SystemUserData/data-statistics/marketPage",
        meta: {
          title: "微营销工作台",
          icon: "icon-drive",
          affix: false
        }
      },
      {
        path: "wxChat",
        name: "WxChat",
        component: () => "@/views/SystemUserData/wx-chat",
        meta: {
          title: "微营销会话",
          icon: "nav_wechat"
        }
      },
      {
        path: "wxManagement",
        name: "WxManagement",
        component: () => "@/views/SystemUserData/wx-management",
        meta: {
          title: "微信号管理",
          icon: "nav_wechat_magage"
        }
      },
      {
        path: "wxAuthentication",
        name: "WxAuthentication",
        component: () => "@/views/SystemUserData/wx-authentication",
        meta: {
          title: "实名管理",
          icon: "nav_wechat_magage"
        }
      },

      {
        path: "wxBannedRecords",
        name: "WxBannedRecords",
        component: () => "@/views/SystemUserData/wx-banned-records",
        meta: {
          title: "封号记录",
          icon: "nav_wechat_magage"
        }
      },

      {
        path: "wxIpRecords",
        name: "WxIpRecords",
        component: () => "@/views/SystemUserData/wx-ip-records",
        meta: {
          title: "微信号ip管理",
          icon: "nav_wechat_magage"
        }
      },

      {
        path: "groupManagement",
        name: "GroupManagement",
        component: () => "@/views/SystemUserData/group-management",
        meta: {
          title: "社群运营",
          icon: "icon-shequnyunying"
        }
      },
      {
        hidden: true,
        path: "groupManagementConfig/:operateType/:id?",
        name: "GroupManagementConfig",
        props: true,
        component: () => "@/views/SystemUserData/group-management/group-config",
        meta: {
          title: "批量拉群",
          hidden: true,
          tagsFrom: "GroupManagement"
        }
      },

      {
        hidden: true,
        path: "groupManagementConfigDetail/:id",
        name: "GroupManagementConfigDetail",
        component: () => "@/views/SystemUserData/group-management/group-config-detail",
        props: true,
        meta: {
          title: "拉群详情",
          hidden: true,
          tagsFrom: "GroupManagement"
        }
      },

      {
        path: "groupMsg",
        name: "GroupMsg",
        component: () => "@/views/SystemUserData/group-msg",
        meta: {
          title: "消息群发",
          icon: "nav_wechat_magage"
        }
      },
      {
        hidden: true,
        path: "msgConfig/:operateType/:id?",
        name: "MsgConfig",
        props: true,
        component: () => "@/views/SystemUserData/group-msg/msg-config",
        meta: {
          title: "群发消息",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },
      {
        hidden: true,
        path: "msgConfigDetail/:id",
        name: "MsgConfigDetail",
        component: () => "@/views/SystemUserData/group-msg/msg-config-detail",
        props: true,
        meta: {
          title: "群发消息详情",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },
      {
        hidden: true,
        path: "msgConfigDetailNew",
        name: "MsgConfigDetailNew",
        component: () => "@/views/SystemUserData/group-msg/msg-config-detail-new",
        props: true,
        meta: {
          title: "群发消息详情",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },
      {
        hidden: true,
        path: "MsgConfigNew",
        name: "MsgConfigNew",
        props: true,
        component: () => "@/views/SystemUserData/group-msg/msg-config-new",
        meta: {
          title: "新建群发",
          hidden: true,
          tagsFrom: "GroupMsg"
        }
      },
      {
        path: "historyMsg",
        name: "HistoryMsg",
        component: () => "@/views/SystemUserData/history-msg/index",
        meta: {
          title: "历史消息",
          icon: "nav_wechat_history"
        }
      },

      {
        path: "userCenter",
        name: "UserCenter",
        component: () => "@/views/SystemUserData/user-center/index",
        meta: {
          title: "会员中心",
          icon: "nav_wechat_member_center"
        },
        children: [
          {
            path: "list",
            name: "UserCenterList",
            component: () => "@/views/SystemUserData/user-center/list/index",
            meta: {
              title: "会员中心",
              icon: "nav_wechat_member_center",
              parent: "UserCenter"
            }
          },
          {
            hidden: true, // (默认 false)
            path: "list/:id",
            name: "userCenterDetail",
            component: () => "@/views/SystemUserData/user-center/detail/index",
            meta: {
              title: "会员中心详情",
              icon: "nav_wechat_member_center",
              hidden: true
            }
          }
        ]
      },
      {
        path: "exportMembers",
        name: "exportMembers",
        component: () => "@/views/SystemUserData/export-members/index",
        meta: {
          title: "会员导出",
          icon: "icon-huiyuandaochu",
          affix: false
        }
      },
      {
        path: "dataStatis",
        name: "DataStatis",
        component: () => "@/views/SystemUserData/data-statistics/index",
        meta: {
          title: "数据统计",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "customerStatis",
            name: "CustomerStatis",
            component: () => "@/views/SystemUserData/data-statistics/customer/index",
            meta: {
              title: "客户统计",
              icon: "icon-shujutongji",
              affix: false,
              parent: "DataStatis"
            }
          },
          {
            path: "messageStatis",
            name: "MessageStatis",
            component: () => "@/views/SystemUserData/data-statistics/message/index",
            meta: {
              title: "消息统计",
              icon: "icon-yuangongguanli",
              affix: false,
              parent: "DataStatis"
            }
          }
        ]
      },
      {
        path: "wechatMoments",
        name: "WechatMoments",
        component: () => "@/views/SystemUserData/wx-moments",
        meta: {
          title: "朋友圈",
          icon: "nav_moments"
        },
        children: [
          {
            path: "engineMoments",
            name: "EngineMoments",
            component: () => "@/views/SystemUserData/wx-moments/engine/index",
            meta: {
              title: "批量发圈",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            path: "editMoments",
            name: "EditMoments",
            hidden: true,
            component: () => "@/views/SystemUserData/wx-moments/engine/edit/index",
            meta: {
              title: "发表朋友圈",
              tagsFrom: "EngineMoments"
            }
          },
          {
            path: "commentMoments",
            name: "CommentMoments",
            component: () => "@/views/SystemUserData/wx-moments/comment/index",
            meta: {
              title: "朋友圈评论",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            hidden: false,
            path: "viewMoments",
            name: "ViewMoments",
            component: () => "@/views/SystemUserData/wx-moments/view/index",
            meta: {
              title: "查看朋友圈",
              affix: false,
              parent: "WechatMoments"
            }
          },
          {
            path: "sourceMoments",
            name: "SourceMoments",
            component: () => "@/views/SystemUserData/wx-moments/source/index",
            meta: {
              title: "朋友圈素材",
              affix: false
            }
          },
          {
            path: "SourceMomentsEdit/:id",
            name: "SourceMomentsEdit",
            component: () => "@/views/SystemUserData/wx-moments/source/edit",
            meta: {
              title: "朋友圈素材-编辑",
              affix: false,
              parent: "WechatMoments",
              tagsFrom: "SourceMoments"
            },
            hidden: true
          },
          {
            path: "sourceMomentsAdd",
            name: "SourceMomentsAdd",
            component: () => "@/views/SystemUserData/wx-moments/source/add",
            meta: {
              title: "朋友圈素材-新增",
              affix: false,
              parent: "WechatMoments",
              tagsFrom: "SourceMoments"
            },
            hidden: true
          },
          {
            path: "autoSendMoment",
            name: "AutoSendMoment",
            component: () => "@/views/SystemUserData/wx-moments/autoSendMoment",
            meta: {
              title: "自动发圈设置",
              affix: false
            }
          }
        ]
      },
      {
        path: "automaticOperation",
        name: "AutomaticOperation",
        component: () => "@/views/SystemUserData/automatic-operation/index",
        meta: {
          title: "自动化运营",
          icon: "icon-shujutongji"
        },
        children: [
          {
            path: "greeting",
            name: "Greeting",
            component: () => "@/views/SystemUserData/automatic-operation/greeting/index",
            meta: {
              title: "客户欢迎语",
              affix: false,
              parent: "AutomaticOperation"
            }
          },
          {
            hidden: true,
            path: "greetingConfig/:operateType/:id?",
            name: "GreetingConfig",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/greeting/greeting-config",
            meta: {
              title: "客户欢迎语设置",
              tagsFrom: "Greeting",
              hidden: true
            }
          },
          {
            hidden: true,
            path: "greetingDetail/:id",
            name: "GreetingDetail",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/greeting/greeting-detail",
            meta: {
              title: "客户欢迎语详情",
              tagsFrom: "Greeting",
              hidden: true
            }
          },
          {
            path: "automaticFans",
            name: "AutomaticFans",
            component: () => "@/views/SystemUserData/automatic-operation/automatic-fans",
            meta: {
              title: "自动加粉",
              affix: false
            }
          },
          {
            hidden: true,
            path: "automaticRecord/:id",
            name: "AutomaticRecord",
            props: true,
            component: () => "@/views/SystemUserData/automatic-operation/automatic-record",
            meta: {
              title: "自动加粉详情",
              icon: "icon-shujutongji",
              tagsFrom: "AutomaticFans",
              affix: false
            }
          }
        ]
      },
      {
        path: "riskControl",
        name: "RiskControl",
        component: () => "@/views/SystemUserData/risk-control",
        meta: {
          title: "风控设置",
          icon: "nav_risk"
        }
      },
      {
        path: "sensitiveWords",
        name: "SensitiveWords",
        component: () => "@/views/SystemUserData/sensitive-words",
        meta: {
          title: "敏感词设置",
          icon: "icon-huiyuandaochu"
        }
      },
      {
        path: "sensitiveWordsConfig/:operate/:id?",
        name: "SensitiveWordsConfig",
        component: () => "@/views/SystemUserData/sensitive-words/config",
        meta: {
          title: "敏感词设置",
          icon: "icon-huiyuandaochu",
          tagsFrom: "SensitiveWords"
        },
        hidden: true,
        props: true
      },
      {
        path: "warnTable",
        name: "WarnTable",
        component: () => "@/views/SystemUserData/warn-table/index",
        meta: {
          title: "告警表",
          icon: "menu_warn"
        }
      }
    ]
  },

  {
    path: "/plm",
    component: Layout,
    name: "Plm",
    meta: {
      title: "产品研发",
      icon: "icon-shangpinzhongxin"
    },
    children: [
      {
        path: "list",
        name: "PlmList",
        component: () => "@/views/Plm/list/index",
        meta: {
          title: "要货计划单",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Plm"
        }
      },
      {
        path: "operation",
        name: "PlmOperation",
        component: () => "@/views/Plm/list/operation.vue",
        meta: {
          title: "要货计划单-",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "OperationConfrim",
        name: "OperationConfrim",
        component: () => "@/views/Plm/list/OperationConfrim.vue",
        meta: {
          title: "要货计划单-确认下单",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "OperationCancel",
        name: "OperationCancel",
        component: () => "@/views/Plm/list/OperationCancel.vue",
        meta: {
          title: "要货计划单-取消下单",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "OperationRevocation",
        name: "OperationRevocation",
        component: () => "@/views/Plm/list/OperationRevocation.vue",
        meta: {
          title: "要货计划单-撤回",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "OperationDelete",
        name: "OperationDelete",
        component: () => "@/views/Plm/list/OperationDelete.vue",
        meta: {
          title: "要货计划单-删除",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "inventoryledger",
        name: "Inventoryledger",
        component: () => "@/views/inventoryledger/index",
        meta: {
          title: "库存台账",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Plm"
        }
      },
      {
        path: "inventoryRatio",
        name: "InventoryRatio",
        component: () => "@/views/inventoryRatio/index",
        meta: {
          title: "库存配置比例",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Plm"
        }
      },

      {
        hidden: true,
        path: "detail",
        name: "PlmDetail",
        props: true,
        component: () => "@/views/Plm/list/detail",
        meta: {
          title: "要货计划单-操作",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        hidden: true,
        path: "detailNew",
        name: "PlmDetailNew",
        props: true,
        component: () => "@/views/Plm/list/new-detail.vue",
        meta: {
          title: "要货计划单-详情",
          hidden: true,
          tagsFrom: "PlmList"
        }
      },
      {
        path: "reserveStorageList",
        name: "reserveStorageList",
        component: () => "@/views/Plm/reserveStorage/reserveStorageList.vue",
        meta: {
          title: "预约入库单",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Plm"
        }
      },
      {
        hidden: true,
        path: "reserveStorageAddOrEdit",
        name: "reserveStorageAddOrEdit",
        props: true,
        component: () => "@/views/Plm/reserveStorage/reserveStorageAddOrEdit.vue",
        meta: {
          title: "预约入库单-新增/编辑",
          hidden: true,
          tagsFrom: "reserveStorageList"
        }
      },
      {
        hidden: true,
        path: "reserveStorageDetail",
        name: "reserveStorageDetail",
        props: true,
        component: () => "@/views/Plm/reserveStorage/reserveStorageDetail.vue",
        meta: {
          title: "预约入库单-详情",
          hidden: true,
          tagsFrom: "reserveStorageList"
        }
      },
      {
        path: "processTable",
        name: "ProcessTable",
        component: () => "@/views/Plm/processTable/index.vue",
        meta: {
          title: "渠道大货进度表",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Plm"
        }
      },
      {
        hidden: true,
        path: "changeLog",
        name: "changeLog",
        props: true,
        component: () => "@/views/Plm/list/changeLog.vue",
        meta: {
          title: "变更记录",
          hidden: true,
          parent: "Plm"
        }
      },
      {
        hidden: true,
        path: "changeLogDetail",
        name: "changeLogDetail",
        props: true,
        component: () => "@/views/Plm/list/changeLogDetail.vue",
        meta: {
          title: "要货计划单-详情",
          hidden: true,
          tagsFrom: "changeLog"
        }
      }
    ]
  },
  {
    path: "/scm",
    component: Layout,
    name: "Scm",
    meta: {
      title: "SCM",
      icon: "icon-dingdanzhongxin"
    },
    children: [
      {
        path: "feedback",
        name: "DeliveryFeedback",
        props: true,
        component: () => "@/views/Plm/delivery-feedback/index.vue",
        meta: {
          title: "交期反馈",
          icon: "icon-shangpinliebiao"
        }
      }
    ]
  },
  {
    path: "/material",
    component: Layout,
    name: "Material",
    meta: {
      title: "素材中心",
      icon: "icon-shangpinzhongxin"
    },
    children: [
      {
        path: "list",
        name: "MaterialLibrary",
        component: () => "@/views/Material/library/materialIndex",
        meta: {
          title: "素材库",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Material"
        }
      },
      {
        path: "recycleIndex",
        name: "RecycleIndex",
        component: () => "@/views/Material/library/recycleIndex",
        meta: {
          title: "回收站",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Material"
        }
      },
      {
        path: "goodsInfo",
        name: "GoodsInfo",
        component: () => "@/views/goodsInfo",
        meta: {
          title: "商品资料",
          icon: "icon-shangpinliebiao",
          affix: false,
          parent: "Material"
        }
      }
    ]
  },
  {
    path: "/ta",
    component: Layout,
    name: "TA",
    meta: {
      title: "AI+文案生成",
      icon: "icon-shangpinzhongxin"
    },
    children: [
      {
        path: "chat",
        name: "Chat",
        component: () => "",
        meta: {
          title: "TATA",
          requiresAuth: true
        }
      },
      {
        path: "image-gen-v2",
        name: "Image",
        component: () => "",
        meta: {
          title: "AI生图",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/financialCenter",
    component: Layout,
    name: "FinancialCenter",
    meta: {
      title: "财务中台",
      icon: "icon-shangpinzhongxin"
    },

    children: [
      {
        path: "purchasingBudgetList",
        name: "purchasingBudgetList",
        props: true,
        component: () => "@/views/purchasingBudget/purchasingBudgetList.vue",
        meta: {
          title: "采买预算",
          icon: "icon-shangpinliebiao"
        }
      },
      {
        path: "departmentalAnnualBudget",
        name: "DepartmentalAnnualBudget",
        props: true,
        component: () => "@/views/departmentalAnnualBudget/index.vue",
        meta: {
          title: "部门年度预算",
          icon: "icon-shangpinliebiao"
        }
      },
      {
        path: "departmentalAnnualBudgetDetail",
        name: "DepartmentalAnnualBudgetDetail",
        props: true,
        component: () => "@/views/departmentalAnnualBudget/detail.vue",
        meta: {
          title: "费用明细",
          hidden: false,
          tagsFrom: "DepartmentalAnnualBudget"
        }
      }
    ]
  },
  {
    path: "/supplyChainManagement",
    component: Layout,
    name: "SupplyChainManagement",
    meta: {
      title: "SupplyChainManagement",
      icon: "icon-dingdanzhongxin"
    },
    children: [
      {
        path: "feedback",
        name: "deliveryFeedback",
        props: true,
        component: () => "@/views/Scm/delivery-feedback/index.vue",
        meta: {
          title: "交期反馈",
          icon: "icon-shangpinliebiao"
        }
      },
      {
        path: "standard",
        name: "SupplierStandard",
        component: () => "@/views/supplier/standard/index",
        meta: {
          title: "服务标准信息",
          icon: "icon-shujutongji"
        }
      },
      {
        path: "data",
        name: "SupplierData",
        component: () => "@/views/supplier/supplierData/index",
        meta: {
          title: "供应商服务数据",
          icon: "icon-yuangongguanli"
        }
      },
      {
        path: "bill",
        name: "SupplierBill",
        component: () => "@/views/supplier/bill/index",
        meta: {
          title: "供应商账单",
          icon: "icon-yuangongguanli"
        }
      },
      {
        path: "issue",
        name: "IssueRecords",
        component: () => "@/views/supplier/issueRecords/index",
        meta: {
          title: "服务问题记录",
          icon: "icon-yuangongguanli"
        }
      }
    ]
  }
]

const oneDimensionalArray = []
const doArr = (arr, prefix) => {
  arr.forEach(item => {
    if (prefix) {
      item.path = prefix + "/" + item.path
    }
    oneDimensionalArray.push(item)
    if (item.children && item.children.length > 0) {
      doArr(item.children, item.path)
    }
  })
}
doArr(matchRoute)
export default oneDimensionalArray
